@use './variables' as *;

:host {
  display: $workers-compensation-class-host-display;
}

.workers-compensation-class {
  display: $workers-compensation-class-display;
  flex-direction: $workers-compensation-class-flex-direction;
}
